import React from "react";
import FormLabel from "@material-ui/core/FormLabel";
import {dir} from "../App";
import {getLabel} from "../localization/MainLocalization";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

export const MaleFemaleCheckBox = props =>{
    return(
        <>
            <FormLabel
                className="w-100 text-start"
            >
                {getLabel("assigned_to")}
            </FormLabel>
            <FormGroup row >
                <FormControlLabel disabled={props.disabled}
                    control={<Checkbox checked={props.for_males || false}
                                       style={{color:"darkgreen"}}
                                       onChange={e => {
                                           if (!props.viewOnly){
                                           props.onChangeHandle(e.target.name,e.target.checked);
                                           }
                                       }} name={props.male_name}/>}
                    label={getLabel("males")}
                />

                <FormControlLabel
                    disabled={props.disabled}
                    control={<Checkbox checked={props.for_females || false}
                                       onChange={e => {
                                           if (!props.viewOnly){
                                           props.onChangeHandle(e.target.name,e.target.checked);
                                           }
                                       }} name={props.female_name} />}
                    label={getLabel("females")}
                />

            </FormGroup>
        </>
    );
}